import { GenresListOut, Level1Out, ReducedMarketplaceProductOut } from '../apiLibx';
import { Action } from 'redux';

export const LIBX_UPDATE_PRODUCT_IN_PRODUCT_LIST_REQUEST = 'LIBX_UPDATE_PRODUCT_IN_PRODUCT_LIST_REQUEST';
export const LIBX_UPDATE_PRODUCT_IN_PRODUCT_LIST_SUCCESS = 'LIBX_UPDATE_PRODUCT_IN_PRODUCT_LIST_SUCCESS';
export const LIBX_UPDATE_PRODUCT_IN_PRODUCT_LIST_FAILURE = 'LIBX_UPDATE_PRODUCT_IN_PRODUCT_LIST_FAILURE';

export const LOCAL_CONTENT_LOCAL_REGIONS_REQUEST = 'LOCAL_CONTENT_LOCAL_REGIONS_REQUEST';
export const LOCAL_CONTENT_LOCAL_REGIONS_SUCCESS = 'LOCAL_CONTENT_LOCAL_REGIONS_SUCCESS';
export const LOCAL_CONTENT_LOCAL_REGIONS_FAILURE = 'LOCAL_CONTENT_LOCAL_REGIONS_FAILURE';

export const LOCAL_CONTENT_GENRES_REQUEST = 'LOCAL_CONTENT_GENRES_REQUEST';
export const LOCAL_CONTENT_GENRES_SUCCESS = 'LOCAL_CONTENT_GENRES_SUCCESS';
export const LOCAL_CONTENT_GENRES_FAILURE = 'LOCAL_CONTENT_GENRES_FAILURE';

export const LIBX_GENRES_SET_GENRE = 'LIBX_GENRES_SET_GENRE';
export const LIBX_GENRES_UNSET_GENRE = 'LIBX_GENRES_UNSET_GENRE';

export const LIBX_LOCAL_REGIONS_SET_LOCAL_REGION = 'LIBX_LOCAL_REGIONS_SET_LOCAL_REGION';
export const LIBX_LOCAL_REGIONS_UNSET_LOCAL_REGION = 'LIBX_LOCAL_REGIONS_UNSET_LOCAL_REGION';

export type LocalContentLocalRegionsRequest = Action<typeof LOCAL_CONTENT_LOCAL_REGIONS_REQUEST>;
export type LocalContentLocalRegionsSuccess = {
    type: typeof LOCAL_CONTENT_LOCAL_REGIONS_SUCCESS;
    payload: Array<Level1Out>;
};
export type LocalContentLocalRegionsFailure = Action<typeof LOCAL_CONTENT_LOCAL_REGIONS_FAILURE>;

export type LibxLocalRegionsSetLocalRegion = {
    type: typeof LIBX_LOCAL_REGIONS_SET_LOCAL_REGION;
    payload: string;
};
export type LibxLocalRegionsUnsetLocalRegion = Action<typeof LIBX_LOCAL_REGIONS_UNSET_LOCAL_REGION>;

export type LibxGenresSetGenre = {
    type: typeof LIBX_GENRES_SET_GENRE;
    payload: string;
};
export type LibxGenresUnsetGenre = Action<typeof LIBX_GENRES_UNSET_GENRE>;

export type LocalContentGenresRequest = Action<typeof LOCAL_CONTENT_GENRES_REQUEST>;
export type LocalContentGenresSuccess = {
    type: typeof LOCAL_CONTENT_GENRES_SUCCESS;
    payload: GenresListOut;
};
export type LocalContentGenresFailure = Action<typeof LOCAL_CONTENT_GENRES_FAILURE>;

export type LibxUpdateProductInProductListRequest = Action<typeof LIBX_UPDATE_PRODUCT_IN_PRODUCT_LIST_REQUEST>;
export type LibxUpdateProductInProductListFailure = Action<typeof LIBX_UPDATE_PRODUCT_IN_PRODUCT_LIST_FAILURE>;
export type LibxUpdateProductInProductListSuccess = {
    type: typeof LIBX_UPDATE_PRODUCT_IN_PRODUCT_LIST_SUCCESS;
    payload: ReducedMarketplaceProductOut;
};

export type LibxAction =
    | LocalContentLocalRegionsRequest
    | LocalContentLocalRegionsSuccess
    | LocalContentLocalRegionsFailure
    | LibxLocalRegionsSetLocalRegion
    | LibxLocalRegionsUnsetLocalRegion
    | LibxGenresSetGenre
    | LibxGenresUnsetGenre
    | LocalContentGenresRequest
    | LocalContentGenresSuccess
    | LocalContentGenresFailure;
